module.exports = __webpack_public_path__ + "static/media/building_selected.be5e4e8a.svg";